import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { key: String }

  connect() {
    const remembered = this.read()
    if (remembered) this.element.open = remembered === 'open'
    this.remember = () => this.write(this.element.open ? 'open' : 'closed')
    this.element.addEventListener('toggle', this.remember)
  }

  disconnect() {
    this.element.removeEventListener('toggle', this.remember)
  }

  get storageKey() {
    return `plaza:section:${this.keyValue}`
  }

  read() {
    try {
      return window.localStorage.getItem(this.storageKey)
    } catch {
      return null
    }
  }

  write(state) {
    try {
      window.localStorage.setItem(this.storageKey, state)
    } catch {
      return
    }
  }
}
